import "dayjs/locale/ru";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as MobxProvider } from "mobx-react";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { NotificationProvider } from "providers";
import reportWebVitals from "./reportWebVitals";
import mobxStores, { StoresProvider } from "stores";
import App from "./App";
import { WebSettingsProvider } from "providers/WebSettingsProvider";

import "./styles/index.css";
import "./styles/custom-antd.css";

dayjs.extend(updateLocale);
dayjs.updateLocale("ru", {
  weekStart: 1,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <NotificationProvider>
      <StoresProvider stores={mobxStores}>
        <MobxProvider {...mobxStores}>
          <WebSettingsProvider>
            <App />
          </WebSettingsProvider>
        </MobxProvider>
      </StoresProvider>
    </NotificationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
